export function noop () {};

export function currentCompetence () {
    const date = new Date();
    const year = date.getFullYear().toString().substring(2);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");

    return `${year}${month}`;
}

export function lastCompetence () {
    const current = currentCompetence();
    return addCompetence(current, -1);
}

export function nextCompetence () {
    const current = currentCompetence();
    return addCompetence(current, +1);
}

export function addCompetence (competence: string, shift: number) {
    const year = parseInt(competence.substring(0, 2)) + 2000;
    const month = parseInt(competence.substring(2)) - 1;

    const date = new Date(year, month, 1);
    const sDate = new Date(date.setMonth(date.getMonth() + shift));
    
    const sYear = sDate.getFullYear().toString().substring(2);
    const sMonth = (sDate.getMonth() + 1).toString().padStart(2, '0');

    return `${sYear}${sMonth}`;
}

export function syncWait (ms: number) {
    const end = Date.now() + ms
    while (Date.now() < end) continue
};

export function isString (value: string | null | undefined) {
    return typeof(value) === "string";
}

export function addDays (date: Date, days: number) {
    date.setDate(date.getDate() + days);
    return date;
}

export function firstDayOfTheMonth (date: Date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function lastDayOfTheMonth (date: Date) {
    return new Date(firstDayOfTheMonth(addMonth(date, 1)).getTime() - 1);
}

export function addMonth (date: Date, shift: number) {
    return new Date(date.setMonth(date.getMonth() + shift));
}

export function toIdentifier (value: string) {
    return value.replace(/[/|\\:*?"<>]/g, " ");
}